module.exports = __webpack_public_path__ + "img/REG_ALIM_SANS_PORC.f22bdb1c.svg";